<template>
  <div class="kaart-reunie">
      <img src="../assets/kaart_zuilen_hd.jpg">
      <img class="logo" src="../assets/logo.png" alt="logo">
      <div class="button-home"><router-link to="/"><img src="../assets/buttons/button_home.svg" alt="button home"></router-link></div>
      <div class="button-map"><router-link to="/kaart"><img src="../assets/buttons/button_map.svg" alt="button map"></router-link></div>
      <div class="button-map-reunies"><img src="../assets/buttons/button_map_reunies.svg" alt="button map"></div>
      <div v-bind:key="pin.id" v-for="pin in pins" style="position: absolute;" v-bind:style="{ top: pin.y + 'px', left: pin.x + 'px' }">
        <img class="pin" v-if="pin.mediaType === 'video'" src="../assets/pins/Zuilen_pin_reunie.svg" alt="pin"  @click="showVideo(pin.linkId)">
        <div class="pintext" v-if="pin.mediaType === 'video'" @click="showVideo(pin.linkId)">{{ pin.pin }}</div>
        <img class="pin" v-if="pin.mediaType === 'still'" src="../assets/pins/Zuilen_pin_reunie.svg" alt="pin"  @click="showStill(pin.linkId)">
        <div class="pintext" v-if="pin.mediaType === 'still'" @click="showStill(pin.linkId)">{{ pin.pin }}</div>
      </div>
  </div>
</template>

<script>
import config from '../config/app.json';
import axios from 'axios';
import router from '../router';
export default {
  name: 'KaartReunies',
  props: [],
  data() {
    return {
      pins: []
    };
  },
  methods: {
      showInfo: (idIn) => {
          router.push('/item/' + idIn);
      },
      showVideo: (idIn) => {
          router.push('/reunievideo/' + idIn);
      },
      showStill: (idIn) => {
          router.push('/reuniestill/' + idIn);
      }
  },
  created() {
    axios.get(config.api + 'items?collection=2&key=' + config.api_key)
    .then((res) => {
      res.data.forEach(record => {
        var pinItem = {
          "id": 0,
          "title": '',
          "pin": null,
          "x": null,
          "y": null,
          "mediaType": '',
          "linkId": null
        };
        // console.log('record: ' + record.id);
        pinItem.id = record.id;
        axios.get(config.api + 'files?item=' + pinItem.id + '&key=' + config.api_key)
        .then((pinFilesRes) => {
          if(record.item_type.id === 3) {
            pinItem.mediaType = 'video';
          }
          if(record.item_type.id === 6){
            pinItem.mediaType = 'still';
          }
          console.log('record itemtypeid: '+ record.item_type.id);
          console.log('pintype: '+ pinItem.mediaType);
          record.element_texts.forEach(text_element => {
            if(text_element.element.name === 'Title') {
              console.log('titel: '+ text_element.text);
              pinItem.title = text_element.text;
            }
            if(text_element.element.name === 'Pin') {
              console.log('pin: '+ text_element.text);
              pinItem.pin = text_element.text;
            }
            if(text_element.element.name === 'Xpos') {
              // console.log('xpos: '+ text_element.text);
              pinItem.x = parseInt(text_element.text) - 30;
            }
            if(text_element.element.name === 'Ypos') {
              // console.log('ypos: '+ text_element.text);
              pinItem.y = parseInt(text_element.text - 40);
            }
            pinFilesRes.data.forEach((pinFile => {
              console.log('mimetype: '+pinFile.mime_type);
              // link to video
              if(pinItem.mediaType === 'video' && pinFile.mime_type.slice(0, 6) === 'video/') {
                  pinItem.linkId = pinFile.id;
                  // console.log('link video: '+ pinItem.linkId);
              }
              // link to image
              if(pinItem.mediaType === 'still' && pinFile.mime_type.slice(0, 6) === 'image/') {
                  pinItem.linkId = pinFile.id;
                  // console.log('link still: '+ pinItem.linkId);
              }

            }));
          });
          this.pins.push(pinItem);
          })
        .catch();
      });
    })
    .catch(err => console.log(err));
  }
  
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
.kaart-reunie {
    /* background-image: '../assets/kaart_zuilen_hd.jpg'; */
    width: 1920px;
    height: 1080px;
    overflow: hidden;
    text-align: center;
}
.logo {
    position: absolute;
    top: 80px;
    left: 1645px;
    width: 120px;
    height: auto;
}
.pin {
    position: absolute;
    width: 30px;
    height: auto;
}
.pintext {
  font-weight: 700;
  font-size: 0.6em;
  width: 30px;
  position: relative; 
  /* z-index: 999;  */
  left: 15px; 
  top: 9px;
  color: #000066;
}
.button-home {
    position: absolute;
    top: 117px;
    left: 65px;
    width: 38px;
    height: auto;
}
.button-map {
    position: absolute;
    top: 200px;
    left: 50px;
    width: 50px;
    height: auto;
}
.button-map-reunies {
    position: absolute;
    top: 280px;
    left: 50px;
    width: 50px;
    height: auto;
    opacity: 50%;
}

</style>
